/*       */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { bind, memoize } from 'app/utils/decorators/decoratorUtils';
import { relationDefinitionsListView } from 'store/actions/entities/relationshipsActions';

import FormGenerator from 'app/containers/Designer/Form/components/FormGenerator';
import { get } from 'app/utils/lo/lo';

class AttributeSectionHookAction extends PureComponent {
    static propTypes = {
        details: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
        loadEntity: PropTypes.func.isRequired,
        disabled: PropTypes.bool,
        formTouched: PropTypes.bool,
        resetFormTouched: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.props.relationDefinitionsListView()
    }

    @bind
    @memoize()
    fieldDefinitions() { 
        return [
            {
                type: 'panel',
                properties: {
                    header: 'Triggers',
                    expanded: true,
                },
                children: [
                    {
                        type: 'groupRepeat',
                        properties: {
                            name: 'primary.system_hook_action/hooks',
                            addButtons: true,
                            addDividers: true,
                        },
                        children: [
                            {
                                type: 'typeahead',
                                properties: {
                                    name: 'when',
                                    label: 'When',
                                    options: [
                                        {
                                            label: 'Before',
                                            value: 'before',
                                        },
                                        {
                                            label: 'After',
                                            value: 'after',
                                        },
                                    ],
                                },
                            },
                            {
                                type: 'typeahead',
                                properties: {
                                    name: 'target',
                                    label: 'Target',
                                    options: [
                                        {
                                            label: 'Relationship',
                                            value: 'entity_relation',
                                        },
                                        {
                                            label: 'Team',
                                            value: 'team',
                                        },
                                        {
                                            label: 'Workspace',
                                            value: 'workspace',
                                        },
                                        {
                                            label: 'Entity',
                                            value: 'entity',
                                        },
                                    ],
                                    onChange: (evnt) => [
                                        { action: 'setVariable', ...evnt.target },
                                        { action: 'setVariable', name: 'triggers', value: null },
                                        { action: 'setVariable', name: 'identifiers', value: null },
                                    ],
                                },
                            },
                            {
                                type: 'typeahead',
                                properties: {
                                    name: 'triggers',
                                    label: 'Triggers',
                                    options: [
                                        {
                                            label: 'Add relationship',
                                            value: 'entity_relation_add',
                                        },
                                        {
                                            label: 'Remove relationship',
                                            value: 'entity_relation_remove',
                                        },
                                    ],
                                    multiple: true,
                                    isVisible: (data) => data.target === 'entity_relation',
                                },
                            },
                            {
                                type: 'typeahead',
                                properties: {
                                    name: 'triggers',
                                    label: 'Triggers',
                                    options: [
                                        {
                                            label: 'Add users to team',
                                            value: 'team_add_users',
                                        },
                                        {
                                            label: 'Remove users from team',
                                            value: 'team_remove_users',
                                        },
                                    ],
                                    multiple: true,
                                    isVisible: (data) => data.target === 'team',
                                },
                            },
                            {
                                type: 'typeahead',
                                properties: {
                                    name: 'triggers',
                                    label: 'Triggers',
                                    options: [
                                        {
                                            label: 'Add users to workspace',
                                            value: 'workspace_add_users',
                                        },
                                        {
                                            label: 'Remove users from workspace',
                                            value: 'workspace_remove_users',
                                        },
                                    ],
                                    multiple: true,
                                    isVisible: (data) => data.target === 'workspace',
                                },
                            },
                            {
                                type: 'typeahead',
                                properties: {
                                    name: 'triggers',
                                    label: 'Triggers',
                                    options: [
                                        {
                                            label: 'Entity update',
                                            value: 'entity_update',
                                        },
                                    ],
                                    multiple: true,
                                    isVisible: (data) => data.target === 'entity',
                                },
                            },
                            {
                                type: 'relationDefinitionTypeahead',
                                properties: {
                                    name: 'identifiers',
                                    label: 'Identifiers',
                                    multiple: true,
                                    isVisible: (data) => data.target === 'entity_relation',
                                },
                            },
                            {
                                type: 'teamTypeahead',
                                properties: {
                                    name: 'identifiers',
                                    label: 'Identifiers',
                                    valueField: 'id',
                                    multiple: true,
                                    allowPermissions: false,
                                    isVisible: (data) => data.target === 'team',
                                },
                            },
                            {
                                type: 'workspaceTypeahead',
                                properties: {
                                    name: 'identifiers',
                                    label: 'Identifiers',
                                    valueField: 'id',
                                    multiple: true,
                                    isVisible: (data) => data.target === 'workspace',
                                },
                            },
                            {
                                type: 'entityTypesTypeahead',
                                properties: {
                                    name: 'identifiers',
                                    label: 'Identifiers',
                                    valueField: 'uri',
                                    multiple: true,
                                    isVisible: (data) => data.target === 'entity',
                                },
                            },
                        ],
                    },
                ],
            },
        ];
    }

    @bind
    handleChange(data, change) {
        const { onChange } = this.props;
        if(change.name.includes('.identifiers')) {
            const target = get(data, `${change.name.replace('.identifiers', '')}.target`)
            switch (target) {
                case 'entity':
                    return onChange(data, {
                        ...change,
                        value: change.value ? change.value.map((val) => ({ type: val })) : null,
                    });
                case 'entity_relation':
                    return onChange(data, {
                        ...change,
                        value: change.value ? change.value.map((val) => ({ relationDefinitionId: val.id })) : null,
                    });
                case 'team':
                    return onChange(data, {
                        ...change,
                        value: change.value ? change.value.map((val) => ({ teamId: val })) : null,
                    });
                case 'workspace':
                    return onChange(data, {
                        ...change,
                        value: change.value ? change.value.map((val) => ({ workspaceId: val })) : null,
                    });

                default:
            }

        }
        if(change.name === 'primary.system_hook_action/hooks') {
            return onChange(data, {
                ...change,
                value: change.value?.map ? change.value.map(val => {
                    if(!val.identifiers || !val.target) {
                        return val;
                    }
                    switch (val.target) {
                        case 'entity_relation':
                            return {...val, identifiers : val.identifiers.map(v => ({ relationDefinitionId: v }))};
                        case 'team':
                            return {...val, identifiers : val.identifiers.map(v => ({ teamId: v }))};
                        case 'workspace':
                            return {...val, identifiers : val.identifiers.map(v => ({ workspaceId: v }))};
                        case 'entity':
                            return {...val, identifiers : val.identifiers.map(v => ({ type: v }))};
                        default:
                    }
                }) : change.value,
            })            
        }
        return onChange(data, change);
    }

    @bind
    @memoize()
    normalizeDetails(details, relationDefinitions) {
        let hooks = details?.primary?.['system_hook_action/hooks'];
        if(Array.isArray(hooks)) {
            hooks = hooks.map(hook => {
                switch (hook.target) {
                    case 'entity_relation':
                        return {
                            ...hook,
                            identifiers: (hook.identifiers || [])
                                .map(indtfrs => relationDefinitions?.find(relDef => relDef.id === indtfrs.relationDefinitionId))
                                .filter(Boolean)
                        }
                    case 'team':
                        return {
                            ...hook,
                            identifiers: (hook.identifiers || [])
                                .map(indtfrs => indtfrs.teamId)
                                .filter(Boolean)
                        }
                    case 'workspace':
                        return {
                            ...hook,
                            identifiers: (hook.identifiers || [])
                                .map(indtfrs => indtfrs.workspaceId)
                                .filter(Boolean)
                        }
                    case 'entity':
                        return {
                            ...hook,
                            identifiers: (hook.identifiers || [])
                                .map(indtfrs => indtfrs.type)
                                .filter(Boolean)
                        }
                    default:
                }
                return hook;
            })
        }
        return details && hooks ? {
            ...details,
            primary: {
                ...(details.primary),
                'system_hook_action/hooks': hooks
            }
        } : details;
    }

    render() {
        const { details, disabled, relationDefinitions } = this.props;
        return (
            <FormGenerator 
                root={false} 
                components={this.fieldDefinitions()} 
                data={this.normalizeDetails(details, relationDefinitions)} 
                disabled={disabled} 
                onChange={this.handleChange} 
            />
        );
    }
}

export default connect((state) => ({
    relationDefinitions: state.entities.relationDefinitions.list.records || [],
}), {relationDefinitionsListView})(AttributeSectionHookAction);
